export const selectUserSubscription = (state) =>
  state.userSubscription.userSubscription;

export const setSubscriptionFromApi = (state) => {
  // console.log("state", state);
  const userSubscription = selectUserSubscription(state);
  return userSubscription;
};
